import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    button: 'I understand !',
    content:
      'Change your default preferences in your business settings, and go to the Invoicing Information tab.',
  },
  fr: {
    button: "C'est compris !",
    content:
      'Modifiez les réglages par défaut de vos options dans vos paramètres d’entreprise, dans l’onglet Information de facturation.',
  },
} as const);
